/**
 * Etiqueta com a cobertura do cliente, na lista de atendimentos.
 *
 * ─── PORQUE EXISTE ──────────────────────────────────────────────────────────
 *
 * Saber se o atendimento é pelo INPS ou particular muda o que se faz antes de
 * o doente entrar — e até aqui era preciso abrir a ficha para descobrir. São
 * dois segundos por doente, trinta vezes por dia.
 *
 * ─── DE ONDE VEM ────────────────────────────────────────────────────────────
 *
 * Do campo `beneficio` do orçamento, que já guarda o nome da instituição ou
 * «Particular». Nos tratamentos isolados não há orçamento nenhum, e aí a
 * etiqueta diz «TI».
 *
 * ─── AS CORES ───────────────────────────────────────────────────────────────
 *
 * Particular é o caso comum, e o comum não deve saltar à vista: fica cinzento.
 * Uma instituição muda o que há a fazer (credencial, comparticipação), por isso
 * é que tem cor. E `TI` tem a sua, por ser outra categoria de coisa — não é uma
 * cobertura, é a ausência de orçamento.
 */

const ESTILO_BASE = {
  flexShrink: 0,
  padding: "1px 7px",
  borderRadius: "10px",
  fontSize: "11px",
  fontWeight: 600,
  letterSpacing: "0.3px",
  whiteSpace: "nowrap",
  cursor: "default",
};

const CORES = {
  particular: { backgroundColor: "#eceff1", color: "#546e7a" },
  instituicao: { backgroundColor: "#e3f2fd", color: "#1565c0" },
  isolado: { backgroundColor: "#f3e5f5", color: "#6a1b9a" },
};

const BadgeCobertura = ({ cobertura }) => {
  if (!cobertura) return null;

  const texto = String(cobertura).trim();
  if (texto === "") return null;

  const tipo =
    texto.toUpperCase() === "TI"
      ? "isolado"
      : texto.toLowerCase() === "particular"
        ? "particular"
        : "instituicao";

  /* «Particular» é a maioria das linhas e é a palavra mais comprida de todas —
     por extenso, empurrava o nome do cliente e enchia a coluna de uma
     informação que é justamente a que não exige nada de ninguém. Abreviado, o
     tooltip continua a dizê-lo por extenso. */
  const etiqueta = tipo === "particular" ? "Prt" : texto;

  const titulo =
    tipo === "isolado"
      ? "Tratamento isolado — não pertence a nenhum orçamento"
      : tipo === "particular"
        ? "Particular — sem cobertura de instituição"
        : `Cobertura: ${texto}`;

  return (
    <span style={{ ...ESTILO_BASE, ...CORES[tipo] }} title={titulo}>
      {etiqueta}
    </span>
  );
};

export default BadgeCobertura;
